import React, { Component } from 'react'
import store from 'store'
import { PermissionHelper } from 'helpers'
import Unauthorized from 'views/core/unauthorized'
import Error from 'views/core/error'

class FlowView extends Component {
  constructor (props, title) {
    super(props)
    this.component = this.render
    this.mount = this.componentDidMount
    this.receiveProps = this.componentWillReceiveProps
    this.error = false
    Object.defineProperty(this, 'render', {
      writable: false,
      configurable: true,
      value: () => this._render()
    })
    Object.defineProperty(this, 'componentDidMount', {
      writable: false,
      configurable: true,
      value: () => this._mount()
    })
    Object.defineProperty(this, 'componentWillReceiveProps', {
      writable: false,
      configurable: true,
      value: (nextProps) => this._receiveProps(nextProps)
    })
    store.dispatch({ type: 'SET_NAVIGATION_PROPS', payload: this.props.match })
    if (title) store.dispatch({ type: 'SET_PAGE_TITLE', payload: title })
    this._developer = store.getState().siteReducer.developer
    this._hidePermissionWrapper = store.getState().siteReducer.hidePermissionWrapper
    store.subscribe(() => {
      this._developer = store.getState().siteReducer.developer
      this._hidePermissionWrapper = store.getState().siteReducer.hidePermissionWrapper
    })
  }
  setError (code) {
    this.error = code
  }
  hasReadPermission () {
    if (!this.namespace) return false
    return PermissionHelper.hasPermission(this.namespace) >= 1
  }

  hasWritePermission () {
    if (!this.namespace) return false
    return PermissionHelper.hasPermission(this.namespace) >= 2
  }

  setNamespace (namespace) {
    this.namespace = namespace
  }

  shouldComponentUpdate () {
    if (this.error) return false
    if (this.namespace) {
      if (!PermissionHelper.hasPermission(this.namespace)) return false
    }
    return true
  }

  _mount () {
    if (this.error) return false
    if (this.namespace) {
      if (!PermissionHelper.hasPermission(this.namespace)) return null
    }
    if (typeof this.mount === 'function') return this.mount()
    return false
  }
  _receiveProps (nextProps) {
    if (this.props.match && this.props.match.url !== nextProps.match.url) store.dispatch({ type: 'SET_NAVIGATION_PROPS', payload: nextProps.match })
    if (typeof this.receiveProps === 'function') return this.receiveProps(nextProps)
    return false
  }

  _render () {
    if (this.error) return <Error code={this.error} />
    if (this.namespace) {
      if (!PermissionHelper.hasPermission(this.namespace)) return <Unauthorized />
      if (this._developer && !this._hidePermissionWrapper) return <div className='developer-wrapper view'><div className='header'><small>view requires: {this.namespace}</small></div>{this.component()}</div>
    }
    return this.component()
  }
}

export default FlowView



// WEBPACK FOOTER //
// ./src/components/core/FlowView.js